// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-label {
  border-radius: 12px;
  padding: 2px 8px;
  white-space: nowrap;
  max-width: 120px;
  background-color: rgba(244, 244, 244, 1);
  background-color: var(--component-label-default-color,rgba(244, 244, 244, 1));
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-label:hover {
  background-color: rgba(218, 218, 218, 1);
  background-color: var(--component-label-default-color-hover,rgba(218, 218, 218, 1));
}
.bolt-label.light {
  color: black;
}
.bolt-label.dark {
  color: white;
}
.bolt-label.selected, .bolt-label:focus {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--text-on-communication-background,rgba(255, 255, 255, 1));
  outline: none;
}
.bolt-label:focus {
  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.23);
  box-shadow: 0 0 0 2px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23));
}
.bolt-label .bolt-label-content {
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.bolt-labelgroup-title-wrapper {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-labelgroup-title-wrapper .vss-Icon {
  margin-left: 8px;
}

.bolt-labelgroup-addButton {
  align-self: flex-start;
  margin-left: 11px;
}

.bolt-labelgroup {
  padding: 2px 2px;
}
.bolt-labelgroup.one-line {
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 8px 2px;
}
.bolt-labelgroup.one-line.fade-out {
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgb(0, 0, 0) 20px);
  -webkit-mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0), rgb(0, 0, 0) 20px);
}
.bolt-labelgroup.free-flow {
  flex-wrap: wrap;
  margin-bottom: -6px;
}
.bolt-labelgroup.free-flow .bolt-label {
  margin-bottom: 6px;
}
.bolt-labelgroup .bolt-label {
  margin-right: 6px;
}

.bolt-labelgroup-editable {
  padding: 2px;
}
.bolt-labelgroup-editable .bolt-labelgroup-title-wrapper {
  margin-left: 11px;
}
.bolt-labelgroup-editable .bolt-label-autocomplete {
  margin-bottom: 6px;
  flex-grow: 1;
}
.bolt-labelgroup-editable .bolt-label-autocomplete input {
  border: none;
}
.bolt-labelgroup-editable .bolt-label-autocomplete input:focus {
  outline: none;
}
.bolt-labelgroup-editable .bolt-label:hover {
  cursor: pointer;
}
.bolt-labelgroup-editable:hover:not(.edit) {
  cursor: pointer;
}

.bolt-labelgroup--editableWrapper.default-padding, .bolt-labelgroup--editableWrapper.edit {
  padding: 7px 9px;
}
.bolt-labelgroup--editableWrapper {
  border-radius: 2px;
}
.bolt-labelgroup--editableWrapper.edit {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--communication-background,rgba(0, 120, 212, 1));
  animation: ms-focus-shadow-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-labelgroup--editableWrapper.edit {
    animation: none;
  }
}
.bolt-labelgroup--editableWrapper.edit {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23));
}
.bolt-labelgroup--editableWrapper:hover:not(.edit) {
  cursor: pointer;
}

/*# sourceMappingURL=Label.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Label/Label.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Label/Label.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AASA;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EAGA,wCAVkB;EAWlB,6EC4IW;ECtJb,wBAAwB;EFYtB,kDAAA;AEVJ;AACA;EFeI,wCAAA;EACI,mFAAA;AEbR;AFeI;EACI,YAAA;AEbR;AFgBI;EAEI,YAAA;AEfR;AACA;EACE,sCAAsC;EFmBpC,sEAAA;EACI,6BAAA;EEjBN,qEAAqE;EFoBnE,aAAA;AElBJ;AACA;EFoBQ,6CC2NG;EC7OT,0EAA0E;AAC5E;AFqBA;EACI,mBAAA;EACA,uBCwGW;EC3Hb,kBAAkB;AFqBhB;;AElBJ;EACE,kBAAkB;EFsBpB,wBAAA;EACI,kDAAA;AEpBJ;AACA;EACE,gBAAgB;AFsBlB;;AEnBA;EFsBI,sBAAA;EACI,iBAAA;AEpBR;;AAEA;EFuBQ,gBAAA;AErBR;AACA;EACE,iBAAiB;EFyBf,gBAAA;EACI,gBAAA;AEvBR;AACA;EF2BQ,yEAAA;EACI,uFArFkB;AE4D9B;AF6BI;EACI,eAAA;EE3BN,mBAAmB;AACrB;AF8BA;EACI,kBAhGgB;AEoEpB;AF8BI;EACI,iBAAA;AE5BR;;AAEA;EF+BQ,YAAA;AE7BR;AF+BQ;EACI,iBAAA;AE7BZ;AF+BY;EACI,kBAAA;EE7Bd,YAAY;AFmCN;AEjCR;EACE,YAAY;AFqCV;AEnCJ;EACE,aAAa;AACf;AFuCI;EAEI,eAAA;AEtCR;AFmCA;EAMI,eAAA;AEtCJ;;AAEA;ECvCQ,gBAAA;ADyCR;ACpDI;EHwFA,kBAAA;AEjCJ;AACA;EACE,sCAAsC;EF+BpC,sEAAA;EGjEI,wDAAA;ADqCR;AFiCI;EACI;IE/BJ,eAAe;EACjB;AACF;AACA;EACE,6CAA6C;EAC7C,0EAA0E;AAC5E;AACA;EACE,eAAe;AACjB;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
